import React from 'react'
import * as Request from '../../utilities/request'
import { Col, Row } from 'react-bootstrap'
import DashboardCard from '../../components/dashboard/dashboardCard'
import SelfUtilisation from '../../components/dashboard/selfUtilisation'
import TeamTimesheets from '../../components/dashboard/teamTimesheets'
import RecentInvoices from '../../components/dashboard/recentInvoices'
import { AppContext } from '../../App'
import { Staff } from '../../../../back-end/common/staff'
import { Loading } from '../../components/ui/Loading/Loading'
import InvoicedForPeriod from '../../components/dashboard/invoicedInPeriod'
import UnaddressedWipCard from '../../components/dashboard/unaddressedWip'
import AddressedWipCard from '../../components/dashboard/addressedWip'
import AgedDebtorsCard from '../../components/dashboard/agedDebtors'
import { TestingStaff } from './dashboardWrapper'

interface DirectorSuperManagerDashboardProps {
	firmView: boolean
	isDirector: boolean
	testingStaff?: TestingStaff
}

const DirectorSuperManagerDashboard = ({ firmView, isDirector, testingStaff }: DirectorSuperManagerDashboardProps) => {
	const { appState } = React.useContext(AppContext)

	const [userStaff, setUserStaff] = React.useState<Staff | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const staffWhere = testingStaff ? `s.StaffXpmID==${testingStaff.xpmID}` : `s.UserID==${appState.authState.attributes?.['custom:userId']}`
			const [staffRes] = await Promise.all([Request.get(`staff?where=${staffWhere}`)])

			if (staffRes.data.success && staffRes.data.staff.length === 1) {
				setUserStaff(staffRes.data.staff[0])
			}
		}

		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState])

	return (
		<>
			<Row className="py-4">
				<Col sm={8}>
					<Row>
						<Col sm={6}>
							<UnaddressedWipCard firmView={firmView} testingStaff={testingStaff} />
						</Col>
						<Col sm={6}>
							<Row>
								<Col>
									<AddressedWipCard firmView={firmView} testingStaff={testingStaff} />
								</Col>
							</Row>
							<Row className="pt-4">
								<Col>
									<SelfUtilisation period="month" testingStaff={testingStaff} />
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className="pt-4">
						<Col>
							<AgedDebtorsCard firmView={firmView} testingStaff={testingStaff} />
						</Col>
					</Row>
				</Col>
				<Col sm={4}>
					<Row>
						<Col>
							<InvoicedForPeriod period="year" firmView={firmView} testingStaff={testingStaff} />
						</Col>
					</Row>
					<Row className="pt-4">
						<Col>
							<TeamTimesheets firmView={firmView} testingStaff={testingStaff} />
						</Col>
					</Row>
					<Row className="pt-4">
						<Col>
							{userStaff && userStaff.reportGroupStaffXpmID ? (
								<RecentInvoices isDirectorViewing={isDirector} directorXpmID={userStaff.reportGroupStaffXpmID} />
							) : (
								<DashboardCard background="cornflower">
									<div className="center-flex">
										<Loading show />
									</div>
								</DashboardCard>
							)}
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	)
}

export default DirectorSuperManagerDashboard
